import { Injectable, OnDestroy } from '@angular/core';
import { TaskViewModel } from "../Model/taskViewModel";
import { RequestSummaryViewModel } from '../Model/requestSummaryViewModel';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { BehaviorSubject, Observable, Subscription } from "rxjs";
import { Project } from '../Model/project';
import { ReviewRequest } from '../Model/reviewRequest';
import { AuthService } from '../../auth/service/auth.service';
import { RequestReviewerViewModel } from '../Model/requestReviewerViewModel';
import { ModeratorViewModel } from '../Model/moderatorViewModel';
import { UserInformation } from '../Model/userInformation';
import { OrganisationService } from '../../organisation/organisation/services/organisation.service';
import url from 'src/settings.json';
import { Setting } from '../../common/settings';
import { Query } from '../Model/query';
import { Task } from '../Model/task';
import { PagedResults } from '../Model/pagedresults';
import { ModifiedRequest } from '../Model/modifiedRequest';
import { UpdateRequestViewModel } from '../Model/UpdateRequestViewModel';
import { ReviewerProgressViewModel } from '../Model/ReviewerProgressViewModel';
import { ReviewerChartViewModel } from '../Model/reviewerChartViewModel';

@Injectable({
  providedIn: 'root'
})
export class RequestService implements OnDestroy {
  readonly contentType: string = "Content-Type";
  readonly contentTypeValue: string = "application/json";
  
  currentOrganisation: any;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': this.contentTypeValue,
      //Authorization: 'my-auth-token'
    }),
    params: new HttpParams()
  };
  public countEmitter = new BehaviorSubject<number>(-1);
  organisationSubscriber: Subscription;
  setting: Setting = url;
  currentUser: any;

  constructor(private readonly httpClient: HttpClient,
    private readonly oAuthService: AuthService,
    private readonly organisationService: OrganisationService) {
    this.organisationSubscriber = this.organisationService.organisationEmitter.subscribe({
      next: (value: string) => {
        if (value === '') { this.currentOrganisation = this.organisationService.getLocalStorageItem("CurrentOrganisation") }
        else { this.currentOrganisation = value; }
      }
    });
    this.currentUser = this.oAuthService.claims;    
  }
  ngOnDestroy(): void {
    this.organisationSubscriber.unsubscribe();
  }

  public getrequests(pageSize: number, pageIndex: number): Observable<PagedResults> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    const params = new HttpParams().set('length', pageSize).set('start', pageIndex);
    return this.httpClient.get<PagedResults>(`${url}/api/request/myopenrequeststatistics`, { headers: headers, params: params })
  }

  public getclosedrequests(pageSize: number, pageIndex: number): Observable<PagedResults> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    const params = new HttpParams().set('length', pageSize).set('start', pageIndex);
    return this.httpClient.get<PagedResults>(`${url}/api/request/myclosedrequestStatistics`, { headers: headers, params: params })
  }

  public getallrequests(pageSize: number, pageIndex: number): Observable<PagedResults> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    const params = new HttpParams().set('length', pageSize).set('start', pageIndex);
    return this.httpClient.get<PagedResults>(`${url}/api/request/all`, { headers: headers, params: params })
  }

  public getrequestsummary(id: number): Observable<RequestSummaryViewModel> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    return this.httpClient.get<RequestSummaryViewModel>(`${url}/api/request/requestSummary/` + id, { headers: headers })
  }

  public canModifyRequestSummary(id: number): Observable<RequestSummaryViewModel> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    return this.httpClient.get<RequestSummaryViewModel>(`${url}/api/request/requestSummaryWithLinks/` + id, { headers: headers })
  }

  public getProjects(): Observable<Project[]> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    return this.httpClient.get<Project[]>(`${url}/api/project`, { headers: headers })
  }



  public getrequestReviewers(id: number): Observable<RequestReviewerViewModel[]> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    return this.httpClient.get<RequestReviewerViewModel[]>(`${url}/api/request/reviewers/` + id, { headers: headers })
  }

  public getReviewersProgress(id: number): Observable<ReviewerProgressViewModel[]> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    return this.httpClient.get<ReviewerProgressViewModel[]>(`${url}/api/request/reviewersProgress/` + id, { headers: headers })
  }

  public getrequestModerators(id: number): Observable<ModeratorViewModel[]> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    return this.httpClient.get<ModeratorViewModel[]>(`${url}/api/request/moderators/` + id, { headers: headers })
  }

  public getrequestTasks(id: number): Observable<TaskViewModel[]> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    return this.httpClient.get<TaskViewModel[]>(`${url}/api/request/tasks/` + id, { headers: headers })
  }

  public createReviewRequest(request: ReviewRequest): Observable<ReviewRequest> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    this.httpOptions.headers = this.httpOptions.headers.set(this.contentType, this.contentTypeValue).set('Authorization', `Bearer ${token}`)
    return this.httpClient.post<any>(`${url}/api/request/create`, request, this.httpOptions)
      .pipe(
      //catchError(this.handleError('addRequest'))
    );
  }

  public getLinkedRequestToRequirement(requestId: number, requirementId: number): Observable<any> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    const params = new HttpParams().set('requestId', requestId).set('requirementId', requirementId);
    return this.httpClient.get<ReviewRequest[]>(`${url}/api/requests/related`, { headers: headers, params: params })
  }

  public getTeamMembers(teamId: string, projectId: string): Observable<UserInformation[]> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    const params = new HttpParams().set('projectId', projectId).set('teamId', teamId);
    return this.httpClient.get<UserInformation[]>(`${url}/api/user/team/members`, { headers: headers, params: params })
  }

  public getActiveRequestCount() {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    return this.httpClient.get<number>(`${url}/api/requests/activecount`, { headers: headers })
  }

  public updateRequestSummary(requestSummary: RequestSummaryViewModel): Observable<RequestSummaryViewModel> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();    
    const requestId = requestSummary.requestId;
    const title = requestSummary.title;
    const comment = requestSummary.comment;

    this.httpOptions.params = this.httpOptions.params.set('requestId', requestId).set('title', title).set('comment', comment);
    this.httpOptions.headers = this.httpOptions.headers.set(this.contentType, this.contentTypeValue).set('Authorization', `Bearer ${token}`);
    return this.httpClient.post<any>(`${url}/api/request/update/`, '', this.httpOptions).pipe();
  }

  public editDueDate(requestmodel: UpdateRequestViewModel): Observable<any> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();

    this.httpOptions.headers = this.httpOptions.headers.set(this.contentType, this.contentTypeValue).set('Authorization', `Bearer ${token}`)
    return this.httpClient.post<any>(`${url}/api/request/editDueDate`, requestmodel, this.httpOptions).pipe();
  }

  public closeRequest(requestId: number): Observable<unknown> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    console.log("About to close request: " + requestId);

    this.httpOptions.params = this.httpOptions.params.set('requestId', requestId);
    this.httpOptions.headers = this.httpOptions.headers.set(this.contentType, this.contentTypeValue).set('Authorization', `Bearer ${token}`);
    return this.httpClient.post<any>(`${url}/api/request/close`, '', this.httpOptions).pipe();
  }

  public getCurrentUser(): Observable<UserInformation> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    return this.httpClient.get<UserInformation>(`${url}/api/user/currentuser`, { headers: headers })
  }

  public getQueries(projectName: string): Observable<Query[]> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    const params = new HttpParams().set('project', projectName);
    return this.httpClient.get<Query[]>(`${url}/api/query`, { headers: headers, params: params })
  }
  public getQueryResult(queryId: string, queryUrl: string, projectName: string): Observable<Task[]> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    const params = new HttpParams().set('project', projectName).set('queryId', queryId);
    return this.httpClient.get<Task[]>(`${url}/${queryUrl}`, { headers: headers, params: params })
  }

  public modifyTasksOfRequest(request: ModifiedRequest): Observable<ModifiedRequest> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    this.httpOptions.headers = this.httpOptions.headers.set(this.contentType, this.contentTypeValue).set('Authorization', `Bearer ${token}`);    
    return this.httpClient.post<any>(`${url}/api/request/ModifyTasks`, request, this.httpOptions).pipe();
  }

  public modifyReviewersOfRequest(request: ModifiedRequest): Observable<ModifiedRequest> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    this.httpOptions.headers = this.httpOptions.headers.set(this.contentType, this.contentTypeValue).set('Authorization', `Bearer ${token}`);
    return this.httpClient.post<any>(`${url}/api/request/modifyreviewers`, request, this.httpOptions).pipe();
  }

  public modifyModeratorsOfRequest(request: ModifiedRequest): Observable<ModifiedRequest> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    this.httpOptions.headers = this.httpOptions.headers.set(this.contentType, this.contentTypeValue).set('Authorization', `Bearer ${token}`);
    return this.httpClient.post<any>(`${url}/api/request/modifymoderators`, request, this.httpOptions).pipe();
  }

  public getReviewerChart(id: number, reviewerName: string): Observable<ReviewerChartViewModel> {
    const url = `${this.setting.url}/${this.currentOrganisation}`;
    const token = this.oAuthService.getAccessToken();
    const headers = { 'Authorization': `Bearer ${token}` }
    const params = new HttpParams().set('id', id).set('reviewerName', reviewerName);
    return this.httpClient.get<ReviewerChartViewModel>(`${url}/api/request/reviewerChart`, { headers: headers, params: params })
  }

  private handleError(method: string) {
    console.log('Error occurred in ' + method);
  }
}
